import { storage } from '../util/constants';
import firebase from 'firebase/app';

////////////////////////////////////////////
// direct client firebase bucket access
//     - scalable model, no server needed
//    

// store bulky data into bucket
//
export function bucket_store_string(bucket, file, string) {
    var sref = storage.ref();
    var ref = sref.child(bucket+"/"+file);

    var url = ref.putString(string).then((snapshot) => {
        console.log("bucket.17:  STRING ",file," Stored  ", (snapshot.totalBytes/1000), 'Kbytes');

        var url = ref.getDownloadURL()
        .then(url => {
            console.log("**** STRING BUCKET URL=", url);
            return url
        })
        return url;
    })

    return url;
}


// store bulky data into bucket
//
export function bucket_store_blob(bucket, file, blob) {
    var sref = storage.ref();
    var ref = sref.child(bucket+"/"+file);

    var url = ref.put(blob).then((snapshot) => {
        console.log("bucket.37:  BLOB ",file,"  Stored", (snapshot.totalBytes/1000), "Kbytes");

        var url = ref.getDownloadURL()
        .then(url => {
            console.log("**** STORED BUCKET URL=", url);
            return url
        })
        return url;
    })

    return url;

    /*
    await bucket.upload(file, {
	gzip: true,   // Support HTTP requests with `Accept-Encoding: gzip`
	metadata: {
	    cacheControl: 'public, max-age=31536000', // only use if file will never change
        */
}
